const data = [
  {
    id: 1,
    title: "Apple IPad Air",
    image: "Assets/product103.jpg",
    price: 55000,
    quantity: 1
  },
  {
    id: 2,
    title: "Muscle Power 1",
    image: "Assets/product102.jpg",
    price: 2000,
    quantity: 1
  },
  {
    id: 3,
    title: "Apple IPad Air",
    image: "Assets/product103.jpg",
    price: 55000,
    quantity: 1
  },
  {
    id: 4,
    title: "Adidas Originals Men's Flip Flop  ",
    image: "Assets/product104.jpg",
    price: 3059,
    quantity: 1
  },
  {
    id: 5,
    title: "Amazon Echo Plus",
    image: "Assets/product108.jpg",
    price: 5000,
    quantity: 1
  },
  {
    id: 6,
    title: "Sony PlayStation 5",
    image: "Assets/product106.jpg",
    price: 49990,
    quantity: 1
  },
  {
    id: 7,
    title: " Mi fitbit",
    image: "Assets/product107.jpg",
    price: 2500,
    quantity: 1
  },
  {
    id: 8,
    title: "Amazon Echo Plus",
    image: "Assets/product108.jpg",
    price: 5000,
    quantity: 1
  },
  {
    id: 9,
    title: " Air Max 97",
    image: "Assets/product109.jpg",
    price: 15995,
    quantity: 1
  },
  {
    id: 10,
    title: "Adidas Originals Men's Flip Flop  ",
    image: "Assets/product104.jpg",
    price: 3059,
    quantity: 1
  },
  {
    id: 11,
    title: " Mi fitbit",
    image: "Assets/product107.jpg",
    price: 2500,
    quantity: 1
  },
  {
    id: 12,
    title: "Sony PlayStation 5",
    image: "Assets/product106.jpg",
    price: 49990,
    quantity: 1
  }
];
export default data;
